import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { TokenData } from './token.feature';

export const TokenActions = createActionGroup({
  source: 'TokenState',
  events: {
    Login: props<{ email: string; password: string }>(),
    LoginSuccess: props<{ tokenString: string; tokenData: TokenData }>(),
    LoginFailure: props<{ error: unknown }>(),
    Logout: emptyProps(),
    LogoutSuccess: emptyProps(),
    LogoutFailure: props<{ error: unknown }>(),
    LoadToken: emptyProps(),
    loadTokenSuccess: props<{ tokenString: string; tokenData: TokenData }>(),
    loadTokenFailure: props<{ error: unknown }>(),
  },
});
